// extracted by mini-css-extract-plugin
export default {"-large":"scroll-to-top-module__-large--jf2FZ","container":"scroll-to-top-module__container--SsDYm","scrollButton":"scroll-to-top-module__scrollButton--zSI6o"};